module.exports = __webpack_public_path__ + "img/Udara360-icon.ad3c1650.png";